<template>
  <div>
    <TplListBasic
      :title="title(routeName)"
      :bgcolorClass="bgClass(routeName)"
      :showCard="showSearchCard(routeName)"
    >
      <template v-slot:actions>
        <div class="actions-btns-container">
          <template v-if="routeName===routes.routeQUO">
            <CartSimple />
            <el-button
              type="primary"
              class="btn"
              @click="handleCheckOut()"
              :disabled="!cartsCnt"
            >Check out ></el-button>
          </template>
          <template v-if="routeName===routes.routeOCOP">
            <el-upload action="/api/app/ocops" ref="upload" :headers="uploadHeader" name="file">
              <el-button size="small" type="primary" :on-sucess="handleImportedOcop">Import Data</el-button>
            </el-upload>
          </template>
          <template v-else-if="routeName===routes.routeINV">
            <el-button
              type="primary"
              :class="btnClass(routes.routeINV)"
              @click="handleNew(routes.routeINV)"
            >+ New {{btnName(routes.routeINV)}}</el-button>
            <el-button
              type="primary"
              :class="btnClass('CreditNotes')"
              @click="handleNew(routes.routeCN)"
            >+ New {{btnName(routes.routeCN)}}</el-button>
          </template>
          <template v-else-if="routeName===routes.routeBL">
            <el-button
              type="primary"
              :class="btnClass(routes.routeBL)"
              @click="handleNew(routes.routeBL)"
            >+ New {{btnName(routes.routeBL)}}</el-button>
            <el-button
              type="primary"
              :class="btnClass(routes.routeBCN)"
              @click="handleNew(routes.routeBCN)"
            >+ New {{btnName(routes.routeBCN)}}</el-button>
          </template>
          <template
            v-else-if="routeName===routes.routeInfoSPL ||
                              routeName===routes.routeInfoWH ||
                              routeName===routes.routeInfoBRD ||
                              routeName===routes.routeInfoEMPL"
          >
            <!-- 如果为基础资料后四种，暂时不在界面上不提供new按钮，后续再添加 -->
          </template>
          <template v-else-if="routeName!==routes.routeOCOP && routeName!==routes.routeQUO">
            <el-button
              type="primary"
              :class="btnClass(routeName)"
              @click="handleBaseInfoNew(routeName)"
            >+ New {{btnName(routeName)}}</el-button>
          </template>
        </div>
      </template>
      <template v-slot:search>
        <SearchInputs />
      </template>
      <template v-slot:results>
        <OCOPResults v-if="routeName === routes.routeOCOP" />
        <SearchResults v-else />
        <div class="subtotal-box">
          <div v-if="routeName===routes.routeINV" class="subtotal-text">
            <span class="text-title-bold">Qty. (This page):</span>
            <span class="text-number">{{listSubtotal.subQty}}</span>
            <span class="text-title-bold">Amount (This page):</span>
            <span class="text-number">${{listSubtotal.subAmt}}</span>
          </div>
          <div v-else>&nbsp;</div>
          <Pagination />
        </div>
      </template>
    </TplListBasic>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import TplListBasic from '../components/TplListBasic'
import SearchInputs from '../components/SearchInputs'
import SearchResults from '../components/SearchResults'
import OCOPResults from '../components/OCOPResults'
import CartSimple from '../components/CartSimple'
import Pagination from '../components/Pagination'

import {
  routeQUO,
  routeOCOP,
  routeINV,
  routeCN,
  routePO,
  routeBCN,
  routeBL,
  routeTR,
  routeAJ,
  routeInfoPRDC,
  routeInfoCSR,
  routeInfoSPL,
  routeInfoWH,
  routeInfoBRD,
  routeInfoEMPL
} from '../router'

export default {
  name: 'OrderSearch',
  components: {
    TplListBasic,
    SearchInputs,
    SearchResults,
    OCOPResults,
    CartSimple,
    Pagination
  },
  props: {
    routeName: {
      type: String,
      required: true
    }
  },
  created () {
    if (this.routeName === 'Quotings') {
      this.cartsRestore()
    }
    this.setSearchType(this.routeName)
  },
  data () {
    return {
      // bus: new Vue(),
      routes: {
        routeQUO,
        routeOCOP,
        routeINV,
        routeCN,
        routePO,
        routeBCN,
        routeBL,
        routeTR,
        routeAJ,
        routeInfoPRDC,
        routeInfoCSR,
        routeInfoSPL,
        routeInfoWH,
        routeInfoBRD,
        routeInfoEMPL
      }
    }
  },
  computed: {
    ...mapGetters({
      cartsCnt: 'cart/cartsCnt',
      bgClass: 'prefs/searchBgClass',
      title: 'prefs/getPageTitle',
      btnName: 'prefs/newBtnName',
      btnClass: 'prefs/newBtnClass',
      showSearchCard: 'prefs/showSearchCard'
    }),
    ...mapState('oauth', ['accessToken']),
    ...mapState(['currentAccount']),
    ...mapState('search', {
      listSubtotal: 'listSubtotal'
    }),
    uploadHeader () {
      return {
        // 'Content-type': 'application/json',
        Authorization: this.accessToken,
        'IWE-EID': this.currentAccount.eId
      }
    }
  },
  methods: {
    ...mapActions({
      setSearchType: 'search/initSearch',
      cartsRestore: 'cart/restore'
    }),
    handleNew (routeName) {
      const routeData = this.$router.resolve({
        name: 'OrderAdd',
        params: { routeName: routeName }
      })
      window.open(routeData.href, '_blank')
    },
    handleBaseInfoNew (routeName) {
      switch (routeName) {
        case routeINV:
        case routeCN:
        case routePO:
        case routeBL:
        case routeBCN:
        case routeAJ:
        case routeTR:
          this.handleNew(routeName)
          break
        default:
          const routeData = this.$router.resolve({
            name: 'BaseInfoAdd',
            params: { routeName: routeName }
          })
          window.open(routeData.href, '_blank')
      }
    },
    handleCheckOut () {
      this.$confirm(
        'When checking out for new invoice, Do you want to EMPTY Quoting Cart & Customer?',
        'Confirm',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: 'Empty & GO',
          cancelButtonText: 'just GO',
          type: 'warning'
        }
      )
        .then(() => {
          this.$message({
            type: 'info',
            message: 'Quoting carts has been emptied, and checking out...'
          })
          this._openNewPage('addFromCartAndClear')
        })
        .catch(action => {
          if (action === 'cancel') {
            this._openNewPage('addFromCart')
          } else if (action === 'close') {
          }
        })
    },
    _openNewPage (operation) {
      this.$router.push({
        name: 'OrderAdd',
        params: { routeName: routeINV, operation }
      })
      // window.open(routeData.href, "_blank");
    },
    handleImportedOcop (response) {
      if (response.status === 200) {
        this.$message({
          message: 'Operation successful',
          type: 'success'
        })
      }
    }
  },
  provide () {
    return {
      // bus: this.bus,
      isProductList: true
    }
  },
  watch: {
    routeName: function (newVal) {
      this.setSearchType(newVal)
    }
  }
}
</script>

<style lang="scss" scoped>
.subtotal-box {
  background-color: #fff;
  margin: 1px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.search-area {
  background-color: #fff;
}
.list {
  margin-top: 40px;
  background-color: #ffffff;
}
.btn,
.btn-secondary,
.btn-third {
  height: 32px;
  margin-left: 12px;
  padding: 0 16px;
  line-height: 32px;
}
.btn-secondary {
  background-color: #32c5d2;
  border-color: #32c5d2;
}
.btn-secondary:hover,
.btn-secondary:focus {
  background-color: #46d2df;
  border-color: #46d2df;
}
.btn-third {
  color: #67c23a;
  background-color: #f0f9eb;
  border-color: #c2e7b0;
}
.btn-third:hover,
.btn-third:focus {
  background-color: #67c23a;
  border-color: #c2e7b0;
  color: #f0f9eb;
}
.actions-btns-container {
  display: flex;
  margin-right: 12px;
}
.actions-btns-container {
  display: flex;
  margin-right: 12px;
}

.page-wrapper {
  max-width: 1678px;
}
.viewpage-caption-container {
  display: flex;
  justify-content: space-between;
  height: 32px;
  line-height: 32px;
  margin-bottom: 12px;
}
.title {
  text-align: left;
  font-size: 18px;
  color: #939393;
  text-indent: 8px;
  font-weight: bold;
}
.search-area {
  margin-bottom: 8px;
}
.creditBgColor {
  background-color: #f9f5ec;
}
.pOrderBgColor {
  background-color: #ebf3ebda;
}
.text-title-bold {
  margin-left: 14px;
  font-size: 12px;
  font-weight: bold;
}
.text-number {
  margin-left: 8px;
  font-size: 12px;
  font-weight: bold;
  color: #1c6fc7;
  margin-right: 32px;
}
</style>
